import debounce from 'lodash/debounce';
import { useEffect, useState } from 'react';
import { gtmPushItemListView } from 'modules/gtm/modules/sections/productList/productList';
import { parseDataToGTMItemListView } from 'modules/gtm/utils/parsers';
import { useSiteConfig } from 'modules/shop/siteConfig/hooks';
import { IAdaptedListProduct } from 'commerce/scayle/utils/adapter/types';
import { ClientPageType } from 'src/app/types';

export const useGTMItemListView = () => {
  const { setGtmData, gtmData } = useSiteConfig();
  const [sentList, setSentList] = useState(new Set());

  const filterNewProducts = () => {
    if (gtmData?.productListView) {
      const products = Object.values(gtmData.productListView).filter(
        (item) => !sentList.has(String(item.id)),
      );
      return parseDataToGTMItemListView(products);
    }
    return null;
  };

  const pushItemsToGTM = debounce(() => {
    const parsed = filterNewProducts();
    if (
      parsed?.items?.length &&
      gtmData?.pageType !== ClientPageType.PDP &&
      gtmData?.productListView
    ) {
      gtmPushItemListView(parsed);
      setSentList(new Set(Object.keys(gtmData?.productListView)));
    }
  }, 1000);

  const addProductToGTMList = (product: IAdaptedListProduct) => {
    setGtmData?.((s) => ({
      ...s,
      productListView: {
        ...s.productListView,
        [product.id]: product,
      },
    }));
  };

  useEffect(() => {
    pushItemsToGTM();
  }, [pushItemsToGTM]);

  return {
    addProductToGTMList,
    productListView: gtmData?.productListView,
    pushItemsToGTM,
  };
};
